import React, { useCallback, useEffect, useRef } from 'react';
import GoogleMap from 'react-google-maps/lib/components/GoogleMap';
import Marker from 'react-google-maps/lib/components/Marker';
import InfoWindow from 'react-google-maps/lib/components/InfoWindow';
import classes from './storeCheckoutLocatorModal.css';
import { getTodayStoreHours } from '../../Header/utils';
import getDirectionGoogleMap from '@magento/peregrine/lib/util/getDirectionGoogleMap';
import { mapEnvironment } from './googleMapHoc';
import { useIntl } from 'react-intl';
var {
  MarkerClusterer
} = require('react-google-maps/lib/components/addons/MarkerClusterer');
var GoogleMapContainer = props => {
  var {
    stores,
    setSelectedStore,
    openInfoWindow,
    setOpenInfoWindow,
    searchedLocation
  } = props;
  var mapRef = useRef(null);
  var {
    formatMessage
  } = useIntl();
  var STATIC_STIRNGS = {
    getDirections: formatMessage({
      defaultMessage: 'Get Directions',
      id: 'GetDirection'
    })
  };
  var fitBounds = useCallback(() => {
    var bounds = new window.google.maps.LatLngBounds();
    if (openInfoWindow) {
      bounds.extend({
        lat: parseFloat(openInfoWindow.latitude + 0.001),
        lng: parseFloat(openInfoWindow.longitude + 0.001)
      });
      bounds.extend({
        lat: parseFloat(openInfoWindow.latitude - 0.001),
        lng: parseFloat(openInfoWindow.longitude - 0.001)
      });
      bounds.extend({
        lat: parseFloat(openInfoWindow.latitude),
        lng: parseFloat(openInfoWindow.longitude)
      });
    } else {
      stores.forEach(store => {
        bounds.extend({
          lat: parseFloat(store.latitude),
          lng: parseFloat(store.longitude)
        });
      });
    }
    if (searchedLocation && !openInfoWindow) {
      bounds.extend(searchedLocation);
    }
    mapRef.current.fitBounds(bounds);
  }, [openInfoWindow, searchedLocation, stores]);
  useEffect(() => {
    if (stores.length > 0) fitBounds();
  }, [stores, fitBounds, searchedLocation, openInfoWindow]);
  var _indexMarker = 0;
  return /*#__PURE__*/React.createElement(GoogleMap, {
    zoom: 8,
    center: openInfoWindow ? {
      lat: parseFloat(openInfoWindow.latitude),
      lng: parseFloat(openInfoWindow.longitude)
    } : null,
    ref: mapRef
  }, /*#__PURE__*/React.createElement(MarkerClusterer, null, searchedLocation ? /*#__PURE__*/React.createElement(Marker, {
    position: searchedLocation
  }) : null, stores && stores.map(store => {
    var {
      name,
      address,
      city,
      region,
      zipcode,
      country,
      phone,
      latitude,
      longitude,
      store_id,
      schedule,
      is_active,
      marker
    } = store;
    if (!is_active) return null;
    var {
      time,
      todayLabel
    } = getTodayStoreHours({
      schedule
    });
    var addressCode = " ".concat(city, ", ").concat(region, ", ").concat(zipcode, ", ").concat(country == 'CA' ? 'Canada' : '');
    return /*#__PURE__*/React.createElement(Marker, {
      key: store_id,
      position: {
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
      },
      id: marker || 1,
      onClick: () => {
        setOpenInfoWindow && setOpenInfoWindow(store);
      },
      className: classes.marker,
      label: "".concat(marker || '')
    }, openInfoWindow && openInfoWindow.store_id === store_id && /*#__PURE__*/React.createElement(InfoWindow, {
      onCloseClick: () => {
        setOpenInfoWindow && setOpenInfoWindow(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.infoWindow
    }, /*#__PURE__*/React.createElement("button", {
      onClick: () => {
        setSelectedStore(store);
      },
      className: classes.name
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.indexMarker
    }, _indexMarker), /*#__PURE__*/React.createElement("span", null, name)), /*#__PURE__*/React.createElement("div", {
      className: classes.address
    }, address), /*#__PURE__*/React.createElement("div", {
      className: classes.addressCode
    }, addressCode), /*#__PURE__*/React.createElement("a", {
      href: "tel:".concat(phone),
      className: classes.phone
    }, phone), /*#__PURE__*/React.createElement("div", {
      className: classes.dayTimeRowToday
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.todayLabel
    }, formatMessage({
      defaultMessage: todayLabel,
      id: todayLabel
    })), /*#__PURE__*/React.createElement("div", null, time)), /*#__PURE__*/React.createElement("button", {
      className: classes.getDirectionButton,
      onClick: () => {
        getDirectionGoogleMap({
          address,
          city,
          country,
          region,
          zipcode,
          lat: latitude,
          lng: longitude
        });
      }
    }, STATIC_STIRNGS.getDirections))));
  })));
};
export default mapEnvironment(GoogleMapContainer);